import { Routes } from '@angular/router';
import { RoleNames, RoutePaths } from '../shared/api/types/enums';
import { RoleGuard } from '../shared/guards/role.guard';
import { AuthGuard } from '../auth/auth.guard';

// User Management
export const userManagementRoutes: Routes = [
  {
    path: RoutePaths.UserManagementUsers,
    loadChildren: () => import('src/app/crm/users/users.module').then((mod) => mod.UsersModule),
    data: { role: [RoleNames.user] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.UserManagementUsersDetails,
    loadChildren: () =>
      import('src/app/crm/users/user-details/user-details.module').then((mod) => mod.UserDetailsModule),
    data: { role: [RoleNames.user] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.UserManagementFavorites,
    loadChildren: () => import('src/app/crm/favorites/favorites.module').then((mod) => mod.FavoritesModule),
    data: { role: [RoleNames.shop, RoleNames.product] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.UserManagementOrderlists,
    loadChildren: () => import('src/app/crm/orderlists/orderlists.module').then((mod) => mod.OrderlistsModule),
    data: { role: [RoleNames.shop, RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.UserManagementLoginTokens,
    loadChildren: () => import('src/app/admin/login-tokens/login-tokens.module').then((mod) => mod.LoginTokensModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  }
];
